import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import ActiveSessionModal from "../../../components/active_session";
import { CONSTANT } from "../../../shared/constants/constant-data";
import { useTokens, useStorageManager, useAuth } from "../../../shared/hooks";
import { parseRoles } from "../shared/utils";
import Loading from "../../../components/loader";
import { setIsBothCloudAndPremAssetUser, setIsNewUserTrue, setIsOnlyCloudUser, setIsOnlyPremAssetUser, setUserLoginDetails } from "../login/Login_Details_slice";
import { useDispatch } from "react-redux";
import { END_POINTS } from "../../../shared";
import axiosInstance from "../../../axios/axios";
import { authActions } from "../../../store/authSlice";

const SsoLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { ssoLogin } = useAuth();
  const { setAccessTokens } = useTokens();
  const { saveToLocalStorage, setCookie,deleteCookie,removeFromLocalStorage,getFromLocalStorage } = useStorageManager();
  const dispatch=useDispatch();
  

  const [msg, setMsg] = useState("");
  const [showActiveSessionModal, setShowActiveSessionModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const authFlag = searchParams.get("authenticated");
    const message = searchParams.get("message") || "";
    const currentState = searchParams.get("state") || "";

    setMsg(message);

    if (authFlag !== "True") {
      toast.error(message);
      navigate("/login");
      return;
    }

    if (currentState && authFlag === "True") {
      handleSsoLogin();
    }
  }, [searchParams]);

  const handleSsoLogin = async (newSession: boolean = false) => {
    setLoading(true);
    try {
      const response = await ssoLogin(
        searchParams.get("state") || "",
        newSession
      );
      handleSsoLoginCallback(response);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || CONSTANT.TOO_MANY_WRONG_ATTEMPTS
      );
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const handleSsoLoginCallback = (result: any) => {
    const userDetail = {};
    if (result.status === 200) {

      if (result.data.active_session) {
        setShowActiveSessionModal(true);
        return;
      }
      setAccessTokens(result.data);
      deleteCookie('userDetail');
      removeFromLocalStorage('userDetails');
      removeFromLocalStorage('isNewUserDetails')


      if (result.data.permissions?.permissions?.length > 0) {
        const parsedPermissions = parseRoles(result.data.permissions?.permissions);
        saveToLocalStorage(
          "roles",
          parsedPermissions
        );
        dispatch(
          authActions.permission({
            permission: parsedPermissions,
          })
        );
      }
      userDetails();

      //navigate("/dashboard");
      setCookie("userDetail", JSON.stringify(userDetail));
    } else {
      toast.error(msg);
      navigate("/login");
    }
  };

  const userDetails = async ()=>{
    dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: false }));
    dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: false }));
    dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: false }));
    const response = await axiosInstance.get(END_POINTS.USER_DETAILS);
    if(response.status === 200){
      const data = response?.data?.data || [];
      dispatch(authActions.subscriptionData(
            data.subscription_features
          ))
      if(data){
        // encryptionService.setEncryptionAllowed(data?.encrypt);
        setCookie("encryptionAllowed", data?.encrypt.toString());
        saveToLocalStorage("userDetails", data);
        console.log(getFromLocalStorage("userDetails"),data, "userDetails");
        const res = await axiosInstance.get(END_POINTS.IS_NEW_USER);
        let parsed = null;
        if(res.status === 200){
          const isNewUser = res?.data?.data || false;
          parsed = res?.data?.data || false;
                    if (parsed.device_count == 0 && parsed.cloud_count == 0) {
                      dispatch(setIsNewUserTrue({ isNewUserTrue: true }));
                      //dispatch(setIsOnlyCloudUser({ is: true }));
          
                    } 
                    else if (parsed.device_count > 0 && parsed.cloud_count == 0) {
                      dispatch(setIsOnlyPremAssetUser({ isOnlyPremAssetUser: true }));
                    } else if (parsed.device_count == 0 && parsed.cloud_count > 0) {
                      dispatch(setIsOnlyCloudUser({ isOnlyCloudUser: true }));
                    } else if (parsed.device_count > 0 && parsed.cloud_count > 0) {
                      dispatch(setIsBothCloudAndPremAssetUser({ isBothCloudAndPremAssetUser: true }));
                    }
          saveToLocalStorage("isNewUserDetails", isNewUser);
          navigate("/dashboard");
        }
        dispatch(setUserLoginDetails({email:data?.organization_email,firstname:data?.firstname,lastname:data?.lastname,organization:data?.organization_name,role:data?.role_name,organization_id:data?.organization_id,unique_devices:data?.subscription_features?.unique_devices,global_filter:data?.global_filter,sso_enabled:data?.sso_enabled || false}));
        
      }
  }
  }
  const onContinue = () => {
    navigate("/login");
  };

  const onSignInAgain = () => {
    setShowActiveSessionModal(false);
    handleSsoLogin(true);
  };

  return (
    <>
      <Loading show={loading} />;
      {showActiveSessionModal && (
        <ActiveSessionModal
          open={showActiveSessionModal}
          onSignInAgain={onSignInAgain}
          onContinue={onContinue}
        />
      )}
    </>
  );
};

export default SsoLogin;
